import corporateRequest from 'utils/corporateRequest'
import studentRequest from 'utils/studentRequest'

export const getSingleRoleQuestionSet =
  (corpId, roleId) => async (dispatch, getState) => {
    try {
      if (roleId && corpId) {
        const result = await corporateRequest.get(
          `corporate/questionarie/list/${roleId}?forStudent=true`
        )
        return result
      } else {
        console.log('Error in Questionnaire Data Check the Dependencies')
      }
    } catch (error) {
      console.log('Error in Questionnaire Data', error)
    }
  }

export const getSingleRoleStudentQuestionAnswerSet =
  (corpId, roleId) => async (dispatch, getState) => {
    const state = getState()
    const studentId = state?.auth?.studentId
    try {
      if (studentId && roleId && corpId) {
        const result = await studentRequest.get(
          `/students/questionaire/roles/list/${studentId}/${roleId}/${corpId}`
        )
        return result
      } else {
        console.log('Error in Questionnaire Data Check the Dependencies')
      }
    } catch (error) {
      console.log('Error in fetching Data', error)
    }
  }

export const updateSingleRoleStudentAnswerSet =
  payload => async (dispatch, getState) => {
    const state = getState()
    payload.studentId = state?.auth?.studentId
    try {
      if (state?.auth?.studentId) {
        const result = await studentRequest.put(
          `/students/questionaire`,
          payload
        )
        return result
      } else {
        console.log(
          'Error in Updating Questionnaire Data Check the Dependencies'
        )
      }
    } catch (error) {
      console.log('Error in Updating Data', error)
      return error.response.data
    }
  }

export const updateStudentFeedback = payload => async (dispatch, getState) => {
  const state = getState()
  payload.studentId = state?.auth?.studentId
  try {
    if (state?.auth?.studentId) {
      const result = await studentRequest.post(`/students/feedback`, payload)
      return result
    } else {
      console.log('Error in Updating FeedBack  Check the Dependencies')
    }
  } catch (error) {
    console.log('Error in Updating Data', error)
    return error.response.data
  }
}

export const geStudentQuestionaireResult =
  (corpId, roleId) => async (dispatch, getState) => {
    const state = getState()
    const studentId = state?.auth?.studentId
    try {
      if (studentId && roleId && corpId) {
        const result = await studentRequest.get(
          `/students/questionaire/validation/${studentId}/${roleId}/${corpId}`
        )
        return result
      } else {
        console.log('Error in Fetching Student Result Check the Dependencies')
      }
    } catch (error) {
      console.log('Error in  Data', error)
      return error.response.data
    }
  }
